import { isEmpty, isNil, pathOr, Path } from 'ramda';

import { required } from './required';
import { TValidator } from './types';

export const ERR_REQUIRED = 'Required';

export const requiredWithOtherFields: (keys: Path[]) => TValidator = (keys) => (value, allValues) => {
  if (!keys.length) {
    return undefined;
  }

  const partialResults = keys.map((keyItem) => {
    const keyValue = pathOr(undefined, keyItem, allValues);

    return isEmpty(keyValue) || isNil(keyValue);
  });

  const emptyResults = partialResults.filter((partialResult) => !!partialResult);

  // all others required fields are empty - should not be required
  if (emptyResults.length === partialResults.length) {
    return undefined;
  }

  return required(value);
};
